export const serviceCategories = [
  {
    id: 'kesif-projelendirme',
    title: 'Keşif ve Proje Hizmetleri',
    subtitle: 'Profesyonel Analiz ve Planlama',
    description:
      'Uzman ekibimiz mekanınızı detaylı şekilde inceler, risk analizi yapar ve ihtiyaçlarınıza özel yangın güvenlik projesi hazırlar. CE, TSE ve ISO 9001 standartlarına uygun çözümler sunuyoruz.',
    icon: 'ri-draft-line',
    image:
      'https://public.readdy.ai/ai/img_res/33533e05a8e42920866965d4b2cf2318.jpg',
    features: [
      'Yerinde keşif ve risk analizi',
      'Mimari projeye uygun sistem tasarımı',
      'Yangın yönetmeliklerine uygunluk kontrolü',
      'Maliyet analizi ve bütçe planlaması',
      'Teknik şartname hazırlama',
      'Ruhsat ve onay süreçleri desteği',
    ],
    stats: { installations: '450+', accuracy: '%100', response: '24 saat' },
  },
  {
    id: 'kurulum-destek',
    title: 'Kurulum ve Destek Hizmetleri',
    subtitle: 'Hızlı ve Güvenilir Kurulum',
    description:
      'Sertifikalı teknisyenlerimiz yangın algılama sistemlerini profesyonel şekilde kurar ve devreye alır. Tüm kurulum sürecinde kalite kontrol ve test işlemlerini titizlikle gerçekleştiriyoruz.',
    icon: 'ri-tools-line',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20technician%20installing%20fire%20detection%20sensors%20on%20ceiling%20wearing%20safety%20equipment%20and%20uniform%2C%20modern%20commercial%20building%20interior%2C%20installation%20tools%20and%20equipment%20visible%2C%20clean%20professional%20workspace%20with%20ladder%20and%20safety%20gear&width=600&height=400&seq=svc-install1&orientation=landscape',
    features: [
      'Profesyonel sistem kurulumu',
      'Kablolama ve altyapı çalışmaları',
      'Sensör ve dedektör montajı',
      'Merkezi kontrol paneli kurulumu',
      'Sistem testleri ve devreye alma',
      'Personel eğitimi ve kullanım kılavuzu',
    ],
    stats: { installations: '1200+', accuracy: '%99.8', response: '1-3 gün' },
  },
  {
    id: 'bakim-destek',
    title: 'Bakım ve Destek Hizmetleri',
    subtitle: 'Kesintisiz Güvenlik Garantisi',
    description:
      'Yangın algılama sistemlerinizin sürekli çalışır durumda kalması için periyodik bakım ve 7/24 teknik destek hizmeti sunuyoruz. Acil durumlarda anında müdahale garantisi ile yanınızdayız.',
    icon: 'ri-customer-service-2-line',
    image:
      'https://readdy.ai/api/search-image?query=Fire%20safety%20technician%20performing%20maintenance%20check%20on%20smoke%20detector%20with%20testing%20equipment%20and%20digital%20tablet%2C%20professional%20service%20uniform%2C%20modern%20building%20interior%2C%20maintenance%20tools%20and%20diagnostic%20devices%20visible&width=600&height=400&seq=svc-maintain1&orientation=landscape',
    features: [
      'Periyodik bakım ve kontrol',
      'Sensör temizliği ve kalibrasyonu',
      'Sistem performans testleri',
      '7/24 teknik destek hattı',
      'Acil arıza müdahalei',
      'Yedek parça ve malzeme desteği',
    ],
    stats: { installations: '2350+', accuracy: '%99.9', response: '2 saat' },
  },
];

export const processSteps = [
  {
    step: 1,
    title: 'Ücretsiz Keşif',
    description:
      'Uzman ekibimiz mekanınızı yerinde inceler, risk analizi yapar ve ihtiyaçlarınızı belirler.',
    icon: 'ri-search-eye-line',
  },
  {
    step: 2,
    title: 'Proje Tasarımı',
    description:
      'Mekanınıza özel yangın algılama sistemi projesi hazırlanır ve onayınıza sunulur.',
    icon: 'ri-draft-line',
  },
  {
    step: 3,
    title: 'Profesyonel Kurulum',
    description:
      'Sertifikalı teknisyenlerimiz sistemi hızlı ve temiz bir şekilde kurar.',
    icon: 'ri-tools-line',
  },
  {
    step: 4,
    title: 'Test ve Devreye Alma',
    description:
      'Tüm sensörler ve alarmlar tek tek test edilir, sistem devreye alınır.',
    icon: 'ri-checkbox-circle-line',
  },
  {
    step: 5,
    title: 'Eğitim ve Destek',
    description:
      'Personel eğitimi verilir, 7/24 teknik destek hizmeti başlatılır.',
    icon: 'ri-customer-service-2-line',
  },
];

export const whyUsReasons = [
  {
    icon: 'ri-shield-check-line',
    title: 'CE & TSE Sertifikalı',
    description: 'Tüm ürünlerimiz uluslararası güvenlik standartlarını karşılar.',
  },
  {
    icon: 'ri-team-line',
    title: '15+ Yıl Deneyim',
    description: 'Sektörde 15 yılı aşkın tecrübe ile güvenilir çözümler sunuyoruz.',
  },
  {
    icon: 'ri-24-hours-line',
    title: '7/24 Teknik Destek',
    description: 'Acil durumlarda anında müdahale garantisi ile yanınızdayız.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Uygun Fiyat Garantisi',
    description: 'Kaliteden ödün vermeden en uygun fiyat tekliflerini sunuyoruz.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Hızlı Kurulum',
    description: 'Profesyonel ekibimiz ile kurulumlar 1-3 gün içinde tamamlanır.',
  },
  {
    icon: 'ri-service-line',
    title: 'Periyodik Bakım',
    description: 'Düzenli bakım hizmetleri ile sisteminiz her zaman çalışır durumda.',
  },
];
